export default "__VITE_ASSET__GGonSM$d__"